import { Shield, Ruler, Wrench, Heart, DollarSign, Star } from 'lucide-react';

const benefits = [
  {
    icon: Heart,
    title: 'Family Business Values',
    description: 'As a proud father-son team, we treat every customer like family with honest, personalized service.',
  },
  {
    icon: Ruler,
    title: 'Expert Measurement',
    description: 'Precise measurements ensure a perfect fit every time, eliminating gaps and ensuring smooth operation.',
  },
  {
    icon: Wrench,
    title: 'Professional Installation',
    description: 'Our experienced team handles the complete installation, leaving your home spotless.',
  },
  {
    icon: Shield,
    title: 'Quality Guaranteed',
    description: 'We only work with premium materials and stand behind every product we install.',
  },
  {
    icon: DollarSign,
    title: 'Competitive Pricing',
    description: 'Fair, transparent pricing with no hidden fees. We ensure you get the best value.',
  },
  {
    icon: Star,
    title: '30+ Years Experience',
    description: 'Three decades of expertise serving Phoenix homes means we know what works best.',
  },
];

export function WhyChooseUs() {
  return (
    <section id="why-us" className="py-20 md:py-28">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block px-4 py-1.5 bg-sage-light text-sage rounded-full text-sm font-medium mb-4">
              Why Choose Us
            </span>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
              The Ted's Difference
            </h2>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              For over 30 years, we've been transforming Phoenix homes with beautiful, 
              functional window treatments. Our commitment to quality, integrity, and 
              customer satisfaction sets us apart.
            </p>
            
            <blockquote className="border-l-4 border-sage pl-6 py-2 italic text-foreground/80">
              "Blessed are those who observe justice, who do righteousness at all times!"
              <footer className="mt-2 text-sm text-muted-foreground not-italic">
                - Psalm 106:3
              </footer>
            </blockquote>
          </div>

          {/* Right Grid */}
          <div className="grid sm:grid-cols-2 gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={benefit.title}
                className="p-6 bg-card rounded-xl shadow-soft hover:shadow-medium transition-all duration-300 group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-12 h-12 rounded-xl bg-sage-light flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <benefit.icon className="w-6 h-6 text-sage" />
                </div>
                <h3 className="font-display text-lg font-semibold text-foreground mb-2">
                  {benefit.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
